module.exports = __webpack_public_path__ + "static/pic01-62b6ac180a56df886336ba5228f82506.jpg";